<template>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-between">
    <template class="consolidatedErrors_modal">
      <a-modal v-model="isModalVisible" :maskClosable="false" :closable="false" title="Warning" centered>
        <template slot="footer">
          <a-button key="submit" type="primary" @click="closeModal">
            Ok
          </a-button>
        </template>
        <div>
          <span v-if="expired_items > 0">
            <h3>Products</h3>
            <p class="consolidatedErrors_description"># of items already expired: ({{ expired_items }})</p>
            <hr>
          </span>
          <h3>Incomplete Configuration</h3>
          <p v-for="e in consolidatedErrors" :key="e.description" class="consolidatedErrors_description">
            {{ _.upperCase(e.description) }} ({{ e.errors.length }})
          <ul>
            <li v-for="error in e.errors" :key="`${error + Math.random()}`" class="consolidatedErrors_errors_list">
              {{ _.startCase(error) }} is not properly configured</li>
          </ul>
          </p>
        </div>
      </a-modal>
    </template>
    <div>
      <router-link slot="brand" class="navbar-brand tw-block lg:tw-hidden" to="/" id="ref-login-root" data-test-id="ref-login-root">
        <img src='@/assets/barter-full.png' alt='logobarter'>
      </router-link>
      <h1 class="tw-mt-6 tw-text-2xl lg:tw-text-3xl">Login</h1>
    </div>
    <form role="form">
      <tw-base-input id="ref-login-account-name" data-test-id="ref-login-account-name" label="Account Name" placeholder="Enter account name" v-model="accountName"/>
      <tw-base-input id="ref-login-username" data-test-id="ref-login-username" label="Username" placeholder="Enter your username" v-model="email"/>
      <tw-base-input id="ref-login-password" data-test-id="ref-login-password" label="Password" placeholder="Enter your password" 
        :type="showPassword ? 'text' : 'password'" 
        @keyup.enter="authenticateUser" 
        v-model="password"
        :addon-right-icon="showIcon"
        :addon-right-action="togglePassword"
      />
      <div class="tw-text-right tw-w-full tw--mt-2 tw-mb-6">
        <a href="/password_reset" id="ref-login-forgot-password" data-test-id="ref-login-forgot-password" class="tw-text-blue-500"><small>Forgot password?</small></a>
      </div>

      <div v-show="showReCaptcha" class="tw-my-4">
        <div id="ref-login-recaptcha-container" data-test-id="ref-login-recaptcha-container" class="g-recaptcha tw-flex tw-justify-center" data-sitekey="6Lfx27EmAAAAAFKJgVjC2Kwt83cxbsJsY_WDV324"></div>
      </div>
      
      <div class="tw-flex tw-space-x-2 tw-w-full">
        <tw-base-button 
          id="ref-login-submit"
          data-test-id="ref-login-submit"
          type="primary"
          innerClass="tw-p-2"
          size="sm"
          block
          @click.prevent="authenticateUser"
          :disabled="loading"
        >
          <a-spin v-if="loading" :spinning="loading" />
          <div v-else>Login</div>
        </tw-base-button>
        <tw-base-button
          id="ref-login-time-entry"
          data-test-id="ref-login-time-entry"
          type="warning"
          size="sm"
          block
          hidden
          @click="timeEntry"
        >
          <div>Time Entry</div>
        </tw-base-button>
      </div>
    </form>

    <footer class="tw-text-center tw-text-xs tw-mt-6">
      <span class="tw-text-gray-400 tw-mr-1">Don't have an account?</span>
      <a id="ref-login-signup" data-test-id="ref-login-signup" @click="signUp" class="tw-text-blue-600">Sign up</a>
    </footer>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import axios from "axios";


import Fingerprint2 from 'fingerprintjs2'

var options = {}
var browserId = ""

// import axios from "axios";
var navigate, component_x;
export default {
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'userEmail']),
    showIcon (){
      return [this.showPassword ? 'fa-eye' : 'fa-eye-slash', 'tw-cursor-pointer'].join(' ')
    }
  },
  created: async function () {
    secureStorage.setItem("default_logo", this.default_logo);
    navigate = this.$router;
    component_x = this;
    secureStorage.setItem("developerMode", false);
    if (window.requestIdleCallback) {
      await requestIdleCallback(function () {
        Fingerprint2.get(options, async function (components) {
          var values = components.map(function (component) { return component.value })
          var murmur = Fingerprint2.x64hash128(values.join(''), 31)
          browserId = murmur
          var autoLogin = await HTTPRequest.getRequest(component_x.endPoint + 'backend_sessions/auto_login?machine_id=' + browserId, null, null)
          secureStorage.setItem("autoLogin", autoLogin.status);
          let serverRunning = secureStorage.getItem("serverRunning")
          if (serverRunning == false) {
            navigate.push({ name: "server_maintenance" });
          }
          
          if (autoLogin.status == true && secureStorage.getItem("loggedIn") == true) {
            if (component_x.accountName != "ripple") {
              let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
              if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
                secureStorage.setItem("account_logo", logoSettings[0]["value"]);
              } else {
                secureStorage.setItem("account_logo", this.default_logo);
              }
              navigate.push({name: 'landing_page'});
            } else {
              secureStorage.setItem("account_logo", this.default_logo);
              secureStorage.setItem("accountTemplateName", "Internal");
              navigate.push('dashboard');
            }

            // navigate.push({name: 'landing_page'});
            component_x.$notification['info']({
              message: 'Welcome to BXI',
              description: "You still have an active session for this device."
            });
          }
        })
      })
    }
  },
  mounted: async function() {
    component_x = this;
    this.loadReCaptchaScript();
    if (secureStorage.getItem("loggedIn") == true && secureStorage.getItem("autoLogin") == true) {
      if (component_x.accountName != "ripple") {
        let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
        if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
          secureStorage.setItem("account_logo", logoSettings[0]["value"]);
        } else {
          secureStorage.setItem("account_logo", this.default_logo);
        }
        navigate.push('/landing_page');
      } else {
        secureStorage.setItem("account_logo", this.default_logo);
      }
    }
  },
  data: function () {
    return {
      isModalVisible: false,
      consolidatedErrors: [],
      default_logo: "https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/accounts/irippledemo/1657239408099_070822081646-62-logo2.png",
      email: '',
      password: '',
      accountName: '',
      loading: false,
      clearUsername: '',
      clearAccountName: '',
      businessTypeCode: '',
      recaptchaVerified: false,
      showReCaptcha: false,
      expired_items: 0,
      showPassword: false,
      notification: {}
    }
  },

  methods: {
    ...mapActions(['updateLoggedInStatus', 'updateUserEmail', 'updateDefaultSite']),
    loadReCaptchaScript() {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js";
      script.async = true;
      script.defer = true;
      script.onload = this.initReCaptcha; // Call the initReCaptcha function after the script is loaded
      document.head.appendChild(script);
    },

    initReCaptcha() {
      // Initialize the reCAPTCHA widget and add an event listener
      const recaptchaContainer = document.getElementById("ref-login-recaptcha-container");
      if (recaptchaContainer) {
        grecaptcha.render(recaptchaContainer, {
          sitekey: "6Ld3d7cmAAAAALoZ9E1DjEstSmAYGoetWknCdwuK",
          callback: this.onRecaptchaVerified, // Call the onRecaptchaVerified function when reCAPTCHA is verified
        });
      }
    },
    onRecaptchaVerified(response) {
      this.recaptchaVerified = !!response;
    },
    closeModal() {
      this.isModalVisible = false
      this.consolidatedErrors = []
      navigate.push({name: 'landing_page'});
    },
    timeEntry() {
      this.$router.push("time_entry")
    },
    signUp() {
      let url = 'https://docs.google.com/forms/d/e/1FAIpQLScCFXt0wcYLP1tBssJnE6dxbq44lgzlwEu8xL1aeG6jq4feiw/viewform'
      window.open(url, '_blank', 'noreferrer')
      // this.$router.push("signup_now")
    },
    async clearExistingSession() {
      this.notification = {}
      var post_request = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/delete_existing_session?email=' + this.clearUsername + '&account=' + this.clearAccountName, null, null, false)
      if (post_request.status == true) {
        this.notification.message = 'You have successfully cleared your existing session, please login again.'
        this.notification.type = "success"
        this.notification.icon = "fa-circle-check"
      } else {
        this.notification.message = 'Error clearing existing session.'
        this.notification.type = "danger"
        this.notification.icon = "fa-circle-xmark"
      }
      this.$emit("handleNotifications", this.notification);
    },
    logOut() {
      var id = secureStorage.getItem("sessionId")
      axios({
        method: 'delete',
        url: this.endPoint + '/backend_sessions/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      })
        .then(function () {
          component_x.updateLoggedInStatus(false);
          secureStorage.setItem("loggedIn", false)
          navigate.push('/');
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    authTokenRequest: async function () {
      var md5 = require('md5'); 
      secureStorage.setItem("accessToken", null);
      secureStorage.setItem("refreshToken", null);
      let request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, { account_name: this.accountName, email: this.email, password: md5(this.password), grant_type: "password" })
      if (request["error"] == undefined) {
        secureStorage.setItem("accessToken", request["access_token"]);
        secureStorage.setItem("refreshToken", request["refresh_token"]);
      }

      return request;
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    authenticateUser: async function () {
      this.$emit('changeAuthLayoutSpinning', true);
      this.notification = {}
      this.loading = true
      if (this.accountName.trim() == '' || this.email.trim() == '' || this.password.trim() == '') {
        this.notification.message = "Your account name, email and password are both required fields for login. Please try again."
        this.notification.type = "danger"
        this.notification.icon = "fa-circle-xmark"
        this.loading = false;
      } else if (this.showReCaptcha && !this.recaptchaVerified) {
        this.notification.message = "The reCAPTCHA verification failed. Please try again."
        this.notification.type = "danger"
        this.notification.icon = "fa-circle-xmark"
        this.loading = false;
      } else {
        var passwordResetPayload = { email: this.email, account_name: this.accountName }
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload, true)
        if (post_request["error"] != undefined) {
          // alert("It seems you entered a wrong username/email address. Please try again.")
          if (this.showReCaptcha)
            this.notification.message = "Either the account name, username, or password you entered is incorrect. Please try again."
          else
            this.notification.message = "Please complete the reCAPTCHA to verify and proceed with login."
          this.notification.type = "warning"
          this.notification.icon = "fa-circle-exclamation"
          this.showReCaptcha = true
          this.loading = false;
        } else {
          var invalid_attempts = post_request["success"][0]["invalid_attempts"] + 1
          let expired_at = post_request["success"][0]["expired_at"]
          let is_expired = false
          let status = post_request["success"][0]["status"]
          if (expired_at != null) {
            let date1 = new Date(expired_at)
            let date2 = new Date()
            if (date1 <= date2) {
              is_expired = true
            }
          }

          var err_message = "It seems you've entered a wrong password. Please try again. (Invalid Attempts: " + invalid_attempts + ")"
          post_request = {}
          if (status == "I") {
            post_request["error"] = "Your account is deactivated. Please contact your administrator."
            err_message = post_request["error"]
          } else if (invalid_attempts >= 3) {
            post_request = await this.authTokenRequest();
            if (post_request["error"]) {
              post_request["error"] = "Your account is locked because of three failed attempts. Please contact your administrator."
              err_message = post_request["error"]
            } else post_request = {};
          } else if (is_expired == true) {
            post_request["error"] = "It seems your account has expired. Please contact your administrator."
            err_message = post_request["error"]
          } else {
            var bodyFormData = new FormData();
            bodyFormData.set('email', this.email);
            bodyFormData.append('password', this.password);
            bodyFormData.append('account_name', this.accountName);
            bodyFormData.append('grant_type', 'password');
            var access_token = secureStorage.getItem("refreshToken")
            if (access_token == undefined) {
              post_request = await this.authTokenRequest();
            } else {
              var userName = secureStorage.getItem("userName")
              var email = secureStorage.getItem("email")
              if (this.email == userName || this.email == email) {
                var check_password = await HTTPRequest.postRequest(this.endPoint + "/users/validate_password", null, { account_name: this.accountName, email: this.email, password: this.password }, true)
                if (check_password["error"] == undefined) {
                  post_request = { success: "Password okay" }
                }
                else {
                  this.notification.message = "Either the account name, username, or password you entered is incorrect. Please try again."
                  this.notification.type = "danger"
                  this.notification.icon = "fa-circle-xmark"
                  post_request = { error: "Invalid password" }
                  this.showReCaptcha = true
                  this.loading = false;
                }
              } else {
                post_request = await this.authTokenRequest();
              }
            }
          }

          if (post_request["error"] == undefined) {
            let ip_params = ""
            let ip = ""
            await axios({
              method: 'get',
              url: '//api.ipify.org?format=json',
            })
              .then(function (response) {
                if (response.data != null) {
                  // console.log(response.data.ip)
                  ip = response.data.ip
                  ip_params = "&ip_address=" + response.data.ip
                }
              })
              .catch(function () {
                console.error("Network Error on IPIFY");
              });
              secureStorage.setItem("ipAddress",ip);

            await this.delay(7000);

            var createSession = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions?machine_id=' + browserId + ip_params, null, null)
            if (createSession["error"] != undefined) {
              this.notification.message = createSession["error"]
              this.notification.type = "danger"
              this.notification.icon = "fa-circle-xmark"
              if (createSession["error"] == 'You still have an active session. Please logout.') {
                this.notification.clearExistingSession = this.clearExistingSession
                component_x.clearUsername = this.email
                component_x.clearAccountName = this.accountName
                this.loading = false;
              } else {
                this.notification.clearExistingSession = this.clearExistingSession
                component_x.clearUsername = ''
                component_x.clearAccountName = ''
              }
            } else {
              component_x.clearUsername = ''
              component_x.clearAccountName = ''
              secureStorage.setItem("sessionId", createSession["id"])
              secureStorage.setItem("accountName", component_x.accountName)
              secureStorage.setItem("accountCompanyName", createSession["account_company_name"])
              secureStorage.setItem("userName", createSession["name"])
              secureStorage.setItem("isAccountOwner", createSession["is_account_owner"])
              secureStorage.setItem("userId", createSession["user_id"])
              if(createSession["password_expiration"]!=undefined) secureStorage.setItem("passwordExpiration", createSession["password_expiration"])
              secureStorage.setItem("accountId", createSession["account_id"])
              secureStorage.setItem("defaultSiteId", createSession["default_site_id"])
              secureStorage.setItem("defaultSiteName", createSession["default_site_name"])
              secureStorage.setItem("userCode", createSession["user_name"])
              secureStorage.setItem("email", createSession["name"])
              secureStorage.setItem("isRippleAdmin", createSession["is_admin"])
              secureStorage.setItem("loggedIn", true)
              component_x.updateUserEmail(createSession["name"])
              component_x.updateLoggedInStatus(true)

              //Get alerts/reminders & put in secure storage
              if (component_x.accountName != "ripple") {
              var user_alerts = await HTTPRequest.getRequest(this.endPoint + 'settings/get_user_alerts?userId=' + secureStorage.getItem("userId") + '&defaultSiteId=' + secureStorage.getItem("defaultSiteId") + '', null)
              secureStorage.setItem("userAlerts", ((user_alerts.length > 0) ? JSON.parse(user_alerts[0].system_alert_id) : []))

              //Get user sites
              var userSites = await HTTPRequest.getRequest(this.endPoint + '/users/' + secureStorage.getItem("userId")  + '/valid_sites', null, null)
              secureStorage.setItem("userSites", ((userSites.length > 0) ? userSites : []))

              
                let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
                if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
                  secureStorage.setItem("account_logo", logoSettings[0]["value"]);
                } else {
                  secureStorage.setItem("account_logo", this.default_logo);
                }
              } else {
                secureStorage.setItem("account_logo", this.default_logo);
              }

              if (component_x.accountName != "ripple") {
                // Checks if the required fields are properly configured
                // START
                await HTTPRequest.getRequest(this.endPoint + "check_configurations/check_account_configurations", null).then(
                  (resp) => {
                    resp.forEach((err, idx) => {
                      if (err.errors.length > 0) {
                        if (idx > 1) {
                          err.description += ` template`
                          this.consolidatedErrors.push(err)
                        } else {
                          this.consolidatedErrors.push(err)
                        }
                      }
                    })
                  }
                );
                // END

                // CHECK expired item count
                let expired_count = await HTTPRequest.getRequest(this.endPoint + "inventories/expired_items", null)
                if (expired_count != null) {
                  this.expired_items = expired_count.item_count
                }
                
                if (createSession["terms_url"] == null || createSession["privacy_url"] == null) {
                  this.$notification['warning']({
                    message: 'Missing DPC documents',
                    description: "Please make sure to provide the required documents for DPC compliance."
                  });
                }
                secureStorage.setItem("termsUrl", createSession["terms_url"])
                secureStorage.setItem("privacyUrl", createSession["privacy_url"])
              }

              var site = await HTTPRequest.getRequest(this.endPoint + 'sites/' + createSession["default_site_id"], null)
              if (site.id > 0) {
                secureStorage.setItem("currentSiteSiteType", site.site_type)
              }
              if (this.consolidatedErrors.length > 0) {
                this.isModalVisible = true
              } else {
                if (component_x.accountName != "ripple"){
                  navigate.push({name: 'landing_page'});
                } else{
                  navigate.push('dashboard');
                }
              }
            }
          } else {
            this.notification.message = err_message
            this.notification.type = "danger"
            this.notification.icon = "fa-circle-xmark"
            secureStorage.removeItem("accessToken");
            secureStorage.removeItem("refreshToken");
            this.showReCaptcha = true
            this.loading = false;
          }

        }
      }
      
      // get account business type of the account
      if (this.notification.type != "error" && component_x.accountName != 'ripple'){
        var userId = secureStorage.getItem("userId")
        var account_business_type = await HTTPRequest.getRequest(this.endPoint + '/users/get_account_business_type?user_id=' + userId, null)
        secureStorage.setItem("accountTemplateName", account_business_type.account_template_name);
        if (account_business_type.code == 'CST' || account_business_type.code == 'OTH'){
          this.businessTypeCode = 'SUP'
        } else {
        this.businessTypeCode = account_business_type.code;
        }
        localStorage.setItem("businessTypeCode", JSON.stringify(this.businessTypeCode));
      } else {
        secureStorage.setItem("accountTemplateName", "Internal");
      }
      console.log(this.notification);
      if (this.notification.type){
        this.$emit("handleNotifications", this.notification);
      }
      this.loading = false
      this.$emit('changeAuthLayoutSpinning', false);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  }
}
</script>

<style>
/* .consolidatedErrors_modal{
  height: 100vh !important;
} */
.consolidatedErrors_description {
  font-size: 14px !important;
  font-weight: bold;
  line-height: 1rem !important;
}

.consolidatedErrors_errors_list {
  font-weight: normal;
   line-height: 1.1rem !important;
}
</style>
